export const environment = {
  apiBaseUrl: '',
  appInsightsId: '',
  clientId: '',
  envName: '',
  production: true,
  apiConfig: {
    scopes: [],
    uri: ''
  },
  msalConfig: {
    auth: {
      clientId: '76b06654-2e24-47bf-becd-0a7312e2a597',
      authority: 'https://login.microsoftonline.com/f5c71729-7816-4984-867a-0b3a69f99ff8',
    },
  },
};
